// src/pages/VerifyEmail.jsx
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import PageTitle from '../components/common/pageTitle';

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('Verifying...'); 
  // Possible states: 'Verifying...', 'Verified', 'AlreadyVerified', 'Failed'

  useEffect(() => {
    const verifyUserEmail = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/verify/${token}`);
        const data = await response.json();

        if (response.ok) {
          // Check message to determine if it's newly verified or already verified
          if (data.message === 'Email verified successfully. You can now log in.') {
            setStatus('Verified');
          } else if (data.message === 'Email already verified. You can log in.') {
            setStatus('AlreadyVerified');
          } else {
            // In case we get some unexpected success message
            setStatus('Verified');
          }
        } else {
          setStatus(data.error || 'Verification failed. Invalid or expired token.');
        }
      } catch (err) {
        console.error(err);
        setStatus('Verification failed due to a server error. Please try again later.');
      }
    };

    if (token) {
      verifyUserEmail();
    } else {
      setStatus('No verification token provided.');
    }
  }, [token]);

  return (
    <>
      <PageTitle link={"Verify Email"} pageName={"Verify Email"} />
      <div className="login-area ptb-100">
        <div className="container">
          <div className="login-info">
            {status === 'Verifying...' && (
              <div>
                <h1>Verifying your email...</h1>
                <p>Please wait.</p>
              </div>
            )}

            {status === 'Verified' && (
              <div className="alert alert-success">
                <h1>Email Verified Successfully!</h1>
                <p>Your email has been verified. You can now log in.</p>
                <Link to="/login" className="default-btn border-0 mt-3">
                  Go to Login Page
                </Link>
              </div>
            )}

            {status === 'AlreadyVerified' && (
              <div className="alert alert-info">
                <h1>Email Already Verified</h1>
                <p>You have already verified your email. You can log in.</p>
                <Link to="/login" className="default-btn border-0 mt-3">
                  Go to Login Page
                </Link>
              </div>
            )}

            {status !== 'Verified' && status !== 'AlreadyVerified' && status !== 'Verifying...' && (
              <div className="alert alert-danger">
                <h1>Verification Error</h1>
                <p>{status}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
